export default __webpack_public_path__ + "static/CRM-01 1-eb931298f443ce49ade1d0f16faae61b.png";